import React, { useState } from "react";
import axios from "axios";
import { Button, DotsVertical, Mail01, Menu, Trash01 } from "@opendate-app/setlist";

import { useMarketingSettingsContext } from "../MarketingSettingsIndexContainer";
import { toastSuccess, toastError } from "../../../../shared/toastHelper";
import SendTestOverlay from "./SendTestOverlay";

const RowKebabMenu = ({ sendDomain }) => {
  const {
    csrfToken,
    team,
    venueOwnership,
    updateSendDomains,
  } = useMarketingSettingsContext();

  const [testModalOpen, setTestModalOpen] = useState(false);

  const deleteSendDomain = () => {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    axios.delete(`/teams/${team.id}/venue_ownerships/${venueOwnership.id}/send_domains/${sendDomain.id}`)
      .then(() => {
        toastSuccess("Send domain deleted successfully");

        updateSendDomains(venueOwnership.id, (domains) => domains.filter((domain) => domain.id !== sendDomain.id));
      })
      .catch((_error) => {
        toastError("Could not delete send domain, please try again");
      });
  };

  const items = [
    ...(sendDomain.verified ? [{ key: "test", label: "Send test", icon: Mail01, onClick: () => setTestModalOpen(true) }] : []),
    {
      key: "delete",
      label: "Delete",
      icon: Trash01,
      destructive: true,
      onClick: () => {
        if (window.confirm("Are you sure you want to delete this send domain?")) {
          deleteSendDomain();
        }
      },
    },
  ];

  return (
    <>
      <SendTestOverlay
        open={testModalOpen}
        onClose={() => setTestModalOpen(false)}
        venueOwnership={venueOwnership}
        sendDomain={sendDomain}
      />
      <Menu
        placement="bottom-end"
        minWidth={180}
        items={items}
        trigger={<Button icon={DotsVertical} aria-label={`More actions for ${sendDomain.domain}`} />}
      />
    </>
  );
};

export default RowKebabMenu;
